import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, Dialog } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import { toUSDFormat } from "../../utils/utils";

import { useAppDispatch, useAppSelector } from "../../app/hooks";
import cashImg from "../../assets/imgs/exchange/money.png";
import logoImg from "../../assets/imgs/garage/salary.png";
import { dispatchTxAction } from "../../helper/dispatchTxAction";
import useGameBankBalance from "../../hook/useGameBankBalance";
import useWallet from "../../hook/useWallet";
import { carSellAction, getGarageListAction } from "../../reducers/game.slice";
import { updateCashBalance } from "../../reducers/profile.slice";
import { CarInventoryType } from "../../types/CarInventoryType";

import useStyles from "./GarageSellStyles";

interface GarageSellPopupProps {
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  targetItem: CarInventoryType | null;
}

const GarageSellPopup: React.FC<GarageSellPopupProps> = ({
  openModal,
  setOpenModal,
  targetItem,
}) => {
  const { classes } = useStyles();
  const { account } = useWallet();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { myProfile } = useAppSelector((state) => state.profile);
  const { signMsg, signature } = useAppSelector((state) => state.auth);
  const { updateBalance } = useGameBankBalance(account, signMsg, signature);

  const handleClose = () => {
    setOpenModal(false);
    navigate(location.pathname);
  };

  const handleSellCar = () => {
    if (!targetItem || targetItem.id === undefined) {
      return;
    }

    dispatchTxAction(
      dispatch,
      carSellAction({ itemId: targetItem.id, account }),
      () => {
        setOpenModal(false);
        updateBalance(account, signMsg, signature);
        dispatch(updateCashBalance(account));
        toast.success("Achieved a successful car sale");

        if (myProfile.city === undefined) return;
        dispatch(getGarageListAction({ account }));
      }
    );
  };

  return (
    <Dialog open={openModal} onClose={handleClose} className={classes.body}>
      <Box className={classes.modalContent}>
        <Box className={classes.closeIconBody}>
          <Button onClick={handleClose}>
            <CloseIcon htmlColor="gray" />
          </Button>
        </Box>

        <Box className={classes.contentBody}>
          <Box component={"img"} src={logoImg} className={classes.logoImg} />
          <Box className={classes.titleText}>Sell car</Box>
          <Box>
            {targetItem?.carType.carName} - {targetItem?.car.damagePercent}%
            damage
          </Box>
          <Box
            component={"img"}
            src={`/assets/imgs/cars/${targetItem?.carType.image}.png`}
            className={classes.carImg}
          />
          <Box className={classes.carDetail}>
            <Box component={"img"} src={cashImg} />
            <Box>{toUSDFormat(targetItem?.car.value)}</Box>
          </Box>
          <Box className={classes.buttonGroup}>
            <Button variant="contained" onClick={handleSellCar}>
              Confirm
            </Button>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

export default GarageSellPopup;
